export const BUSINESS = {
  name: "Regina Garage Door Services",
  tagline: "Regina's Garage Door Experts · Available 24/7",
  phone: "306-262-5995",
  phoneHref: "tel:3062625995",
  email: "ReginaGarageDoorServices@gmail.com",
  emailHref: "mailto:ReginaGarageDoorServices@gmail.com",
  area: "Regina & surrounding areas, SK",
};

export const CATEGORIES = [
  {
    id: "residential",
    title: "Residential Garage Door Services",
    subtitle: "Keeping your home safe, functional, and looking its best.",
    linkLabel: "Residential Services",
    items: [
      "Garage door repair",
      "Garage door installation",
      "Garage door replacement",
      "Broken spring service",
      "Cable repair",
      "Roller replacement",
      "Track repair",
      "Panel replacement",
      "Garage door opener service",
      "Maintenance and adjustments",
    ],
  },
  {
    id: "commercial",
    title: "Commercial Garage Door Services",
    subtitle: "Dependable overhead door solutions for businesses and commercial properties.",
    linkLabel: "Commercial Services",
    items: [
      "Commercial overhead doors",
      "Commercial door repair",
      "Installation and replacement",
      "Spring and cable service",
      "Track and roller repair",
      "Commercial door openers",
      "Preventive maintenance",
      "Emergency commercial service",
    ],
  },
  {
    id: "repair",
    title: "Garage Door Repair",
    subtitle: "When your garage door stops working, we're here.",
    linkLabel: "Garage Door Repair",
    items: [
      "Broken springs",
      "Broken cables",
      "Door off track",
      "Damaged rollers",
      "Noisy doors",
      "Door won't open or close",
      "Opener problems",
      "Damaged panels",
      "Uneven or crooked doors",
      "Worn hardware",
    ],
  },
  {
    id: "installation",
    title: "Garage Door Installation",
    subtitle: "A new garage door can transform your home.",
    linkLabel: "Garage Door Installation",
    items: [
      "New garage door installation",
      "Replacement garage doors",
      "Different styles and designs",
      "Residential and commercial applications",
      "Door selection",
      "Professional installation",
    ],
  },
];

export const WHY_US = [
  { icon: "Clock", title: "Available 24/7", text: "Garage door problems don't always happen during business hours. We're available around the clock." },
  { icon: "MapPin", title: "Local Service", text: "We proudly provide garage door services to Regina and surrounding communities." },
  { icon: "Building2", title: "Residential & Commercial", text: "From a single home garage door to commercial overhead doors, we work with different types of customers and projects." },
  { icon: "Hammer", title: "Professional Workmanship", text: "We approach each job carefully and focus on doing the work properly." },
  { icon: "MessageSquare", title: "Clear Communication", text: "We explain the recommended work and answer your questions before proceeding." },
  { icon: "ShieldCheck", title: "Your Property Matters", text: "We treat your home, garage, business, and equipment with care." },
];

export const STEPS = [
  { n: 1, title: "Give Us a Call", text: "Call 306-262-5995 and tell us what's happening with your garage door." },
  { n: 2, title: "We Assess the Problem", text: "We'll inspect the door and identify the issue." },
  { n: 3, title: "We Explain Your Options", text: "We'll explain what needs to be repaired, replaced, or adjusted and discuss the available options with you." },
  { n: 4, title: "Get Your Garage Door Working Again", text: "Once you approve the work, we'll complete the necessary service." },
];

export const GALLERY = [
  { img: "/assets/jobs/door-walnut.jpg", caption: "Walnut wood-look insulated door with window row", tag: "Residential · New Installations" },
  { img: "/assets/jobs/door-white.jpg", caption: "Classic raised-panel steel door, installed and sealed", tag: "Residential · New Installations" },
  { img: "/assets/jobs/opener-wallmount.jpg", caption: "Wall-mount (jackshaft) opener — quiet, and frees the ceiling", tag: "Garage Doors & Openers" },
  { img: "/assets/jobs/offtrack-before-after.jpg", caption: "Off-track door after a vehicle bump — before and after", tag: "Garage Door Repairs" },
  { img: "/assets/jobs/commercial-loading-dock.jpg", caption: "Loading dock overhead doors with dock seals — the type of commercial system we service", tag: "Commercial Overhead Doors" },
  { img: "/assets/jobs/commercial-sectional-doors.jpg", caption: "Commercial sectional overhead doors on a distribution building", tag: "Commercial Overhead Doors" },
];

export const FAQS = [
  { q: "Do you provide 24/7 garage door service?", a: "Yes. Regina Garage Door Services is available 24/7 for garage door service and emergency situations." },
  { q: "Do you repair broken garage door springs?", a: "Yes. Broken springs are one of the most common garage door problems we handle. We service both torsion and extension spring systems for residential and commercial doors." },
  { q: "Do you repair garage doors that are off track?", a: "Yes. Whether the door came off its track after a vehicle bump or from worn hardware, we can assess the door and get it running safely again." },
  { q: "Do you install new garage doors?", a: "Yes. We install new and replacement garage doors in a range of styles and designs for both residential and commercial properties, and we can help you choose the right door." },
  { q: "Do you repair garage door openers?", a: "Yes. We service, repair, and install garage door openers, including remotes, keypads, and smart opener setups." },
  { q: "How much does garage door repair cost?", a: "Every garage door is different. The condition of the door, the type of repair, the parts required, and the door size all affect the work involved. We provide an on-site assessment and discuss the recommended options with you before proceeding." },
];

export const SERVICE_AREAS = ["Regina", "Surrounding communities"];

export const LEAD_SERVICES = [
  "Garage Door Repair",
  "Residential Garage Doors",
  "Emergency Garage Door Service",
  "Broken Spring Repair",
  "Cable Repair & Replacement",
  "Opener Repair & Installation",
  "New Garage Door Installation",
  "Off-Track & Accident Repair",
  "Rollers, Hinges, Bearings & Tracks",
  "Panel & Section Replacement",
  "Weather Seals & Insulation",
  "Remotes, Keypads & Smart Openers",
  "Maintenance & Tune-Ups",
  "Commercial & Overhead Doors",
];
